<template>
  <div class="debug-actions"
       v-if="isDebugEnvironment">
    <!-- FOR TESTING PURPOSES ONLY -->
    <div class="debug-actions--toggle"
        v-b-toggle.debugActionsCollapse>
    </div>
    <b-collapse id="debugActionsCollapse"
                class="debug-actions--collapse">
      <b-row class="spacing-1"
             v-for="(action, index) of debugActions"
             :key="`debugAction${index}`">
        <b-col>
          <b-button @click="action.function">
            {{ action.name }}
          </b-button>
        </b-col>
      </b-row>
    </b-collapse>
  </div>
</template>

<script>
import analytics from '../../../utility/analyticsUtil'
import environment from '../../../utility/environmentUtils'
import { AnalyticsConstants } from '../../../constants.js'

export default {
  name: 'debug-actions',

  data () {
    return {
      isDebugEnvironment: environment.isLowerEnv(),
      debugActions: [
        {
          name: 'Trigger Inbox Message',
          function: () => {
            analytics.logEvent(AnalyticsConstants.eventName.submitContent, { 'item_id': 'inboxMessageTest', 'item_name': 'Inbox Message Test', 'item_variant': 'true' }, { logMarketingEvent: true })
          }
        },
        {
          name: 'Trigger In App Message',
          function: () => {
            analytics.logEvent(AnalyticsConstants.eventName.submitContent, { 'item_id': 'inAppMessageTest', 'item_name': 'In App Message Test', 'item_variant': 'true' }, { logMarketingEvent: true })
          }
        }
      ]
    }
  }
}
</script>

<style scoped>
.debug-actions--toggle {
  width: 100%;
  height: 3.125rem;
}
</style>
